import styled from 'styled-components';

export const RegisterContent = styled.div.attrs({})`
  background: ${(props) => props.theme.palette.colors.white};
  width: 100%;
  padding: 40px;
  height: 100%;
  display: flex;
  gap: 24px;
  flex-direction: column;
  margin-top: 60px;
  @media (max-width: 767px) {
    padding: 20px;
  }
`;
